import { createSelector } from 'reselect';
import { get, isNil, map, pipe, reject } from 'lodash/fp';
import { pointOf } from 'data/geography';
import { coordinatesToBounds } from 'utils/spatialUtils';
import workspaceGeographiesSelector from 'selectors/workspaceGeographiesSelector';
import currentAttributesSelector from './currentAttributesSelector';
import locationsByLayerSelector from './locationsByLayerSelector';

const layerBoundsSelector = createSelector(
  workspaceGeographiesSelector,
  locationsByLayerSelector,
  pipe(currentAttributesSelector, get('values')),
  (geographies, locations, attributeValues) =>
    pipe(
      map('id'),
      map((id) => pointOf(id, attributeValues, geographies)),
      reject(isNil),
      map(({ longitude, latitude }) => [longitude, latitude]),
      coordinatesToBounds,
    )(locations),
);

export default layerBoundsSelector;
